var $ = require('jquery');

$(function () {
    var isPageEditor = window.SitecoreUtilities.isPageEditor;

    if (!isPageEditor()) {
        $('a.OpenInModal').each(function () {
            var thisLink = $(this)[0];
            var iFrameSrc = thisLink.href;
            thisLink.href = "javascript:page-modal";

            $(this).on('click', function () {
                const modalContent = '<div class="modal-wrapper"><span data-fancybox-close></span><iframe src="' + iFrameSrc + '" width="100%" height="500px"></iframe></div>';
                $.fancybox.open({
                    content: modalContent,
                    autoSize: false,
                    fitToView: false,
                    type: 'html',
                    //smallBtn : true,
                    //close: true,
                });
            });
        });

        $('.close-modal').on('click', function () {
            // If the clicked element doesn't have the right selector, do nothing
            event.preventDefault();
            window.parent.document.querySelectorAll("html")[0].className = "";
            var parentPageModal = window.parent.document.documentElement.querySelectorAll(".fancybox-container")[0];
            parentPageModal.parentNode.removeChild(parentPageModal);
        });



        function videoModalAdjustAspectRatio() {
            var iframe = $('.fancybox-content iframe')[0];

            if ($(iframe).find("fancybox-close-small").length == 0) {
                $(iframe).parent().prepend('<button data-fancybox-close class="fancybox-close-small" title="Close"></button>');
            }

            if (iframe) {
                var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                var aspect = 1.78;
                var resizedWidth;
                var playerCalculatedWidth = 500;

                if ($(window).width() >= 768) {
                    playerCalculatedWidth = 667;
                }
                if ($(window).width() >= 992) {
                    playerCalculatedWidth = 960;
                }
                if ($(window).width() >= 1200) {
                    playerCalculatedWidth = 1100;
                }

                if ($('.fancybox-content').height() < playerCalculatedWidth) {
                    var resizedHeight = parseInt($(window).height()) - 200;
                    resizedWidth = resizedHeight * aspect;
                } else {
                    resizedWidth = parseInt($(window).width()) - 100;
                }

                $('.fancybox-content').css({ width: resizedWidth, maxWidth: playerCalculatedWidth });
                $('.fancybox-content').height(resizedWidth / aspect);
            }
        }


        $(window).on('resize orientationchange', function () {
            videoModalAdjustAspectRatio();
        });


        $('a.OpenVideoInModal').each(function () {
            var thisLink = $(this)[0];
            var iFrameSrc = thisLink.href;
            thisLink.href = "javascript:;";

            $(this).on('click', function () {
                $.fancybox.open({
                    src: iFrameSrc,
                    baseClass: 'fancybox-modal-video',
                    type: 'iframe',
                    beforeShow: function () {
                        $('.fancybox-image')
                            .width($(window).width())
                            .height($(window).height());
                        $(".fancybox-inner").find(".fancybox-toolbar").hide();
                    },
                    onUpdate: function () {
                        videoModalAdjustAspectRatio();
                    },
                });
            });
        });
    }
});